import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AlertService, AuthenticationService } from '../_services/index';
import { environment } from '../../environments/environment';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css']
})

export class LoginComponent implements OnInit {
    model: any = {};
    loading = false;
    returnUrl: string;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private authenticationService: AuthenticationService,
        private alertService: AlertService) { }

    ngOnInit() {
        // reset login status
        this.authenticationService.logout();

        // get return url from route parameters or default to '/'
        this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/home';
    }

    login() {
        this.loading = true;
        this.authenticationService.login(this.model.username, this.model.password)
            .subscribe(
                data => {
                    console.log('this.model')
                    console.log(this.model)
                if (this.model.username == 'admin'){
                    localStorage.setItem('editmode', '1');
                    this.router.navigateByUrl('/admin');
                }
                if (this.model.username == 'translator'){
                    console.log(localStorage.getItem('editmode'));
                    localStorage.setItem('editmode', '1');
                    console.log(localStorage.getItem('editmode'));
                    this.router.navigate([this.returnUrl]);
                }
                else{
                    localStorage.setItem('editmode', '0');
                    this.router.navigate([this.returnUrl]);
                }

                },
                error => {
                    this.alertService.error('Invalid username or password.');
                    this.loading = false;
                });

        this.authenticationService.loginGetId(this.model.username, this.model.password)
            .subscribe(
                data => {
/*
                this.userService.getById(JSON.parse(localStorage.getItem('currentUserId')).id)
                .subscribe(
                    data => {
                        this.model.username = data["username"]
                        this.model.first_name = data["first_name"]
                        this.model.last_name = data["last_name"]
                        this.model.email = data["email"]
                        this.model.organization = data["organization"]
                        this.model.team = data["team"]
                        this.model.role = data["role"]
                        this.model.id = data["id"]
                        *//*this.model.password = data["password"]*//*

                    },
                    error => {
                        this.alertService.error(error);
                        this.loading = false;
                });*/
                    console.log(data)
                },
                error => {
                    this.alertService.error('Invalid username or password.');
                    this.loading = false;
                });
    }

    register() {
      this.router.navigateByUrl('/register');
    }
}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts